export class File {

    static download(fileName, data) {

        const blobData = new Blob([data]);

        if (File.browserIsIE11()) {
            window.navigator.msSaveOrOpenBlob(blobData, fileName);
        } else {
            const fileLink = document.createElement('a');
            fileLink.href = window.URL.createObjectURL(blobData);
            fileLink.setAttribute('download', fileName);
            document.body.appendChild(fileLink);
            fileLink.click();
        }
    }

    static extractFileName(contentDisposition) {
        const urlEncoded = contentDisposition.split(';')
            .find(x => x.trim().startsWith("filename*=UTF-8''"))
            .split("''")[1];

        return decodeURIComponent(urlEncoded);
    }

    static browserIsIE11() {
        return window.navigator.msSaveOrOpenBlob !== undefined;
    }
}